module.exports = __webpack_public_path__ + "img/plugeth_bvumad.d9781c44.svg";